import { Tooltip } from '@chakra-ui/react';
import { IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import styled from '@emotion/styled';
import { RightAlign } from '../styles';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';
import { useTranslation } from "react-i18next";

function questionsCompleteSummary(row: any) {
    const { t } = useTranslation('common');
  return (
    <>
      <CompleteSummarySection>
        <CompleteSummaryLabel>{t('common:personalInfo')}</CompleteSummaryLabel>
        <CompleteSummaryValue>
          {row.studentDetailsComplete}/{row.studentDetailsRequired}
        </CompleteSummaryValue>
      </CompleteSummarySection>
      <CompleteSummarySection>
        <CompleteSummaryLabel>{t('common:history')}</CompleteSummaryLabel>
        <CompleteSummaryValue>
          {row.historyComplete}/{row.historyRequired}
        </CompleteSummaryValue>
      </CompleteSummarySection>
      <CompleteSummarySection>
        <CompleteSummaryLabel>{t('common:consents')}</CompleteSummaryLabel>
        <CompleteSummaryValue>
          {row.consentsComplete}/{row.consentsRequired}
        </CompleteSummaryValue>
      </CompleteSummarySection>
      <CompleteSummarySection>
        <CompleteSummaryLabel>{t('common:finance2')}</CompleteSummaryLabel>
        <CompleteSummaryValue>
          {row.financeComplete}/{row.financeRequired}
        </CompleteSummaryValue>
      </CompleteSummarySection>
    </>
  );
}

const QuestionsCompleteFormatter = (cellProps: CellProps) => {
  const { row } = cellProps;
  if (
    row &&
    row.studentDetailsComplete !== undefined &&
    row.studentDetailsRequired !== undefined &&
    row.historyComplete !== undefined &&
    row.historyRequired !== undefined &&
    row.consentsComplete !== undefined &&
    row.consentsRequired !== undefined &&
    row.financeComplete !== undefined &&
    row.financeRequired !== undefined
  ) {
    return (
      <CellEventsHandler cellProps={cellProps}>
        <Tooltip hasArrow placement="top" label={questionsCompleteSummary(cellProps.row)}>
          <RightAlign>{cellProps.row.questionComplete}</RightAlign>
        </Tooltip>
      </CellEventsHandler>
    );
  }
  return (
    <CellEventsHandler cellProps={cellProps}>
      <RightAlign>{cellProps.row.questionComplete}</RightAlign>
    </CellEventsHandler>
  );
};

export const QSColumn = (): IColumn => ({
  item: {
    key: 'questionComplete',
    name: 'Info',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(128px, 1fr)',
    formatter: QuestionsCompleteFormatter,
  },
  visible: ({ isVisaStatusVisible }) => !isVisaStatusVisible,
});

const CompleteSummarySection = styled.div`
  margin: 4px;
  display: flex;
  justify-content: space-between;
`;

const CompleteSummaryLabel = styled.div`
  vertical-align: top;
  font-weight: var(--ds-fontWeights-bold);
  text-align: left;
  margin-right: 4px;
`;

const CompleteSummaryValue = styled(CompleteSummaryLabel)`
  font-weight: var(--ds-fontWeights-normal);
  text-align: right;
`;
